module.exports = __webpack_public_path__ + "img/roll-1249.2465e8a4.png";